import { createContext, useContext, useState } from "react";
import LeadDialog from "@/components/LeadDialog";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [leadOpen, setLeadOpen] = useState(false);
  const [leadPrefill, setLeadPrefill] = useState({});

  const openLead = (prefill = {}) => {
    setLeadPrefill(prefill);
    setLeadOpen(true);
  };

  return (
    <UIContext.Provider value={{ openLead }}>
      {children}
      <LeadDialog open={leadOpen} onOpenChange={setLeadOpen} prefill={leadPrefill} />
    </UIContext.Provider>
  );
}

export const useUI = () => useContext(UIContext);
